import { USER_TYPE } from 'common/constants/app.constants';
import { getFromSessionStorage, setInSessionStorage } from 'common/utils/app.utils';
import { LEAD_STATUS, MODULE_ID } from 'home/common/constants/constants';
import { MULTI_SITE_MODULE_ID } from 'home/view/manage-feasibility/constants';
import { DOA_STATUS, KAM_MESSAGE_STATUS, KAM_META_DATA, TOAST_TYPE } from '../configure-plan-pricing-constant';

const existingARCGreaterThanNewARC = (content) => {
  let isGreater = false;

  const existingARC = content?.oldLineItemDetail?.price?.rental;
  const eligibleForRenewContract = content?.oldLineItemDetail?.eligibleForRenewContract;
  const newARC = content?.planDetail?.price?.amount;
  const isExistingPriceGreaterThanNewPrice = existingARC > newARC;

  if (!eligibleForRenewContract && isExistingPriceGreaterThanNewPrice) {
    isGreater = true;
  }

  return isGreater;
};

const isExistingARCGreaterThanNewARC = (lineItems) => {
  let isPriceGreater = false;
  const currentContent = lineItems?.content;

  if (currentContent?.length > 0) {
    for (let i = 0; i < currentContent.length; i++) {
      if (existingARCGreaterThanNewARC(currentContent[i]?.rawContent)) {
        isPriceGreater = true;
        break;
      }
    }
  }

  return isPriceGreater;
};

export const getStatus = ({ status, doaStatus, leadStatus, totalPrice, totalArcPrice, doaAssignedToUsers }, lineItems) => {
  // will  do refactoring
  let message = '';
  let cssClass = '';
  let toastType = '';
  let disabledAction = false;
  let disabledSumbit = false;
  let doPolling = doaStatus === DOA_STATUS.IN_PROGRESS;
  const kamData = getFromSessionStorage(MULTI_SITE_MODULE_ID, KAM_META_DATA);
  const doaDetails = doaAssignedToUsers?.length ? doaAssignedToUsers[0] : {};
  const { lastAction } = kamData ? kamData : {};
  if (leadStatus === LEAD_STATUS.LEAD_SUBMITTED) {
    message = KAM_MESSAGE_STATUS.LEAD_SUBMITTED;
    cssClass = 'success';
    toastType = TOAST_TYPE.WARNING;
    disabledAction = true;
  } else if (leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED && doaStatus.toUpperCase() === DOA_STATUS.REJECTED) {
    message = KAM_MESSAGE_STATUS.DOA_REJECTED_PRICING;
    cssClass = 'error';
    toastType = TOAST_TYPE.ERROR;
    disabledSumbit = true;
    disabledAction = true;
  } else if (status === LEAD_STATUS.ORDER_IN_PROGRESS && leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION) {
    message = isExistingARCGreaterThanNewARC(lineItems) ? KAM_MESSAGE_STATUS.LOWER_PRICING_BW : KAM_MESSAGE_STATUS.CUSTOMIZED_PRICING;
    cssClass = 'error';
    toastType = TOAST_TYPE.WARNING;
  } else if (status === LEAD_STATUS.ORDER_IN_PROGRESS && doaStatus === DOA_STATUS.IN_PROGRESS && leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT) {
    message =
      lastAction === DOA_STATUS.CLARITY_SUBMITTED
        ? KAM_MESSAGE_STATUS.KAM_SUBMIT_CLARITY
        : KAM_MESSAGE_STATUS.DOA_PRICING_REQUEST + ` ${doaDetails?.name} (${doaDetails?.email}, ${doaDetails?.phoneNumber})` + ' for DOA approval.';
    cssClass = 'success';
    toastType = TOAST_TYPE.SUCCESS;
    disabledAction = true;
  } else if (status === LEAD_STATUS.ORDER_IN_PROGRESS && doaStatus === DOA_STATUS.CLARITY_REQUIRED && leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT) {
    message = KAM_MESSAGE_STATUS.DOA_CLARITY_REQUEST;
    cssClass = 'error';
    toastType = TOAST_TYPE.WARNING;
  }
  return { message, cssClass, toastType, disabledAction, doPolling, disabledSumbit, isPriceZero: !(totalPrice + totalArcPrice) };
};

export const saveKAM_META_DATA = (configuration) => {
  setInSessionStorage(MULTI_SITE_MODULE_ID, KAM_META_DATA, configuration);
};

export const prepareRequestForKAM = (request, { commentText: remarks, attachments }) => {
  const remark = {
    userType: getFromSessionStorage(MODULE_ID, USER_TYPE),
    submitAt: new Date().getTime(),
    remarks
  };
  if (request.doaStatus === DOA_STATUS.CLARITY_REQUIRED) {
    return { remarks };
  }
  return { ...request, attachments: attachments, remarks: request.remarks.concat(remark) };
};
